exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".background-params {\r\n  width: auto;\r\n  background-color: white;\r\n  margin-bottom: 20px;\r\n  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\nh1 {\r\n    text-align: center;\r\n}\r\n\r\np {\r\n    margin-top: 15px;\r\n}\r\n\r\n.container {\r\n    max-width: 900px;\r\n    width: 100%;\r\n}\r\n\r\n.text {\r\n    color: #7a7a7a;\r\n    font-size: 20px;\r\n    font-family: \"Myriad Pro\";\r\n    letter-spacing: -0.025em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/resort/resort.component.css
// module id = 759
// module chunks = 1